import * as React from "react";
import "./static/GuidesView.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Paper, Button, Collapse } from 'react-md';
import { Carousel } from 'react-responsive-carousel';
import { observable, action } from "mobx";
import { observer } from "mobx-react";
type GuideItem = {
    title: string;
    subTitle: string;
    pdfLink: string;
    images: string[];
    isCollapsed: boolean;
};
export class GuidesViewModel {
    @observable guides: GuideItem[] = [
        {
            title: "Add Accounts",
            subTitle: "Learn how to add accounts ",
            pdfLink: "https://portaluidevstorage.blob.core.windows.net/adminguides/addaccount/addaccount.pdf",
            images: [
                "https://portaluidevstorage.blob.core.windows.net/adminguides/addaccount/addaccount.jpg",
                "https://portaluidevstorage.blob.core.windows.net/adminguides/addaccount/addaccount2.jpg",
                "https://portaluidevstorage.blob.core.windows.net/adminguides/addaccount/addaccount3.jpg"
            ],
            isCollapsed: true
        },
        {
            title: "Review Pending Accounts",
            subTitle: "Learn how to review pending accounts and approve them",
            // tslint:disable-next-line:max-line-length
            pdfLink: "https://portaluidevstorage.blob.core.windows.net/adminguides/reviewpending/reviewpending.pdf",
            images: [
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/reviewpending/reviewpending.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/reviewpending/reviewpending2.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/reviewpending/reviewpending3.jpg"
            ],
            isCollapsed: true
        },
        {
            title: "Setting Up Automatic Account Approval",
            subTitle: "Learn how access codes and email patterns work and how to use them",
            // tslint:disable-next-line:max-line-length
            pdfLink: "https://portaluidevstorage.blob.core.windows.net/adminguides/approvalmanagement/approvalmanagement.pdf",
            images: [
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/approvalmanagement/approvalmanagement.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/approvalmanagement/approvalmanagement2.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/approvalmanagement/approvalmanagement3.jpg"
            ],
            isCollapsed: true
        },
        {
            title: "Edit Accounts",
            subTitle: "Learn how to edit accounts ",
            // tslint:disable-next-line:max-line-length
            pdfLink: "https://portaluidevstorage.blob.core.windows.net/adminguides/editaccount/editaccount.pdf",
            images: [
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/editaccount/editaccount.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/editaccount/editaccount2.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/editaccount/editaccount3.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/editaccount/editaccount4.jpg"
            ],
            isCollapsed: true
        },
        {
            title: "Manage Test Results",
            subTitle: "Learn how to manage user results ",
            // tslint:disable-next-line:max-line-length
            pdfLink: "https://portaluidevstorage.blob.core.windows.net/adminguides/managetestresults/managetestresults.pdf",
            images: [
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/managetestresults/managetestresults.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/managetestresults/managetestresults2.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/managetestresults/managetestresults3.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/managetestresults/managetestresults4.jpg"
            ],
            isCollapsed: true
        },
        {
            title: "Sending Push Notifications",
            subTitle: "Learn how to send immediate and deferred push notifications ",
            // tslint:disable-next-line:max-line-length
            pdfLink: "https://portaluidevstorage.blob.core.windows.net/adminguides/sendingpushnotifications/sendingpushnotifications.pdf",
            images: [
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/sendingpushnotifications/sendingpushnotifications.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/sendingpushnotifications/sendingpushnotifications2.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/sendingpushnotifications/sendingpushnotifications3.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/sendingpushnotifications/sendingpushnotifications4.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/sendingpushnotifications/sendingpushnotifications5.jpg",
                // tslint:disable-next-line:max-line-length
                "https://portaluidevstorage.blob.core.windows.net/adminguides/sendingpushnotifications/sendingpushnotifications6.jpg"                
            ],
            isCollapsed: true
        }
    ];
    @action.bound
    onShowClicked(title: string) {
        let itemIndex = this.guides.findIndex(item => item.title === title);
        if (itemIndex > -1) {
            this.guides[itemIndex].isCollapsed = !this.guides[itemIndex].isCollapsed;
        }
    }
}

@observer class GuidesView extends React.Component< {model: GuidesViewModel}, {}> {
   
    render() {
        return (
            <div className="AdminGuidesRoot GeneralViewContainer">
             
                {
                    this.props.model.guides.map((guide, index) => {
                        return (
                            <div key={index} className="row">
                            <div className="AdminGuidesPaperContainer">
                                <h2>{guide.title}</h2>
                                <Paper
                                    zDepth={2}
                                >
                                    <p>{guide.subTitle}</p>
                                    <a href={guide.pdfLink}>Download the PDF version.</a>
                                    <Button
                                        onClick={() => this.props.model.onShowClicked(guide.title)}
                                        raised={true}
                                        secondary={true}
                                    >
                                    {
                                        guide.isCollapsed ?
                                        "Show"
                                        :
                                        "Hide"
                                    }
                                    </Button>
                                    <Collapse collapsed={guide.isCollapsed}>
                                        <Carousel
                                            className='AdminGuidesImageCarousel'
                                            showArrows={true}
                                            showStatus={true}
                                            showIndicators={true}
                                            infiniteLoop={true}
                                            useKeyboardArrows={true}
                                        >
                                        {
                                            guide.images.map(link => {
                                                return (
                                                    <div key={link}>
                                                        <img 
                                                            src={link}
                                                        />
                                                    </div>
                                                );
                                            })
                                        }
                                        </Carousel>
                                    </Collapse>
                                </Paper>
                            </div>
                        </div>
        
                        );
                    })
                }
            </div>
        );
    }
}

export default GuidesView;


// WEBPACK FOOTER //
// ./src/view/Admin/GuidesView/GuidesView.tsx